import React from 'react';
import PropTypes from 'prop-types';

const SecurityShield = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 19 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.4683 5.03065C18.4523 4.86233 18.3939 4.70087 18.2985 4.56146C18.2032 4.42204 18.074 4.30926 17.9233 4.23371L9.97878 0.23402C9.84057 0.163966 9.68795 0.127303 9.53311 0.126956C9.37827 0.126608 9.2255 0.162587 9.08698 0.23202L1.08865 4.23171C0.792707 4.3817 0.588439 4.66868 0.546589 4.99865C0.533636 5.09564 -0.594321 14.7389 9.05708 20.0055C9.20545 20.0867 9.37203 20.1285 9.54102 20.1269C9.71 20.1253 9.87579 20.0804 10.0226 19.9965C19.2964 14.7379 18.5062 5.42462 18.4683 5.03065ZM9.52341 17.9736C2.68791 13.964 2.40891 7.62245 2.48564 5.76959L9.53138 2.24686L16.5044 5.75759C16.5094 7.62745 16.0251 14 9.52341 17.9736Z"
      fill={color}
    />
  </svg>
);

SecurityShield.propTypes = {
  color: PropTypes.string.isRequired,
};

export default SecurityShield;
